import React from 'react';
import { Box } from '@mui/material';
import { motion } from 'framer-motion';
import RecentTradeSignals from '../../../components/RecentTradeSignals';
import { itemVariants } from './utils';

/**
 * SignalsWidget - Wrapper for RecentTradeSignals component
 * Displays recent trade signals from the strategy system
 * 
 * @param {Object} config - Widget configuration
 * @param {number|string} [config.maxHeight] - Maximum height for widget
 */
const SignalsWidget = ({ config = {} }) => {
  const maxHeight = config.maxHeight;
  const containerStyle = maxHeight ? { maxHeight, overflow: 'auto' } : {};

  return (
    <motion.div variants={itemVariants}>
      <Box sx={containerStyle}>
        <RecentTradeSignals title={config?.title} />
      </Box>
    </motion.div>
  );
};

export default SignalsWidget;
